const notify = {
  notify: {
    SUCCESS: 'Success',
    FAILED: 'Failed'
  }
};

export default notify;
